function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(643.052 657.341) rotate(120)",
  opacity: 0.37
}, /*#__PURE__*/React.createElement("path", {
  d: "M-216.4,368.567c37.047,8.907,240.989,147.607,233.488,256.674C9.627,733.663-111.488,726.635-155.762,730.414s-111.387,36.45-155.211-12.827-15.783-80.615-20.548-134.628S-361.028,333.8-216.4,368.567Z",
  transform: "translate(0 -11.968)",
  fill: "#e9eaea"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-329.156 321.176)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-314.34,395.386a6.105,6.105,0,0,1-5.292,6.822,6.105,6.105,0,0,1-6.822-5.293,6.1,6.1,0,0,1,5.293-6.822A6.1,6.1,0,0,1-314.34,395.386Z",
  transform: "translate(326.503 -340.225)",
  fill: "#e9eaea"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-276.305,339.52l-.6.249a9.1,9.1,0,0,1-7.56.093,6.33,6.33,0,0,0-6.655.612,6.257,6.257,0,0,0-2.447,5.823,6.327,6.327,0,0,0,8.7,5.041,6.293,6.293,0,0,0,3.53-3.741,8.755,8.755,0,0,1,4.9-5.195l1.254-.523a7.4,7.4,0,0,1,7.705,1.476,12.639,12.639,0,0,0,14.725,1.322,12.7,12.7,0,0,0,5.706-14.312,12.635,12.635,0,0,0-17.01-8.215,12.632,12.632,0,0,0-7.769,11.18A7.131,7.131,0,0,1-276.305,339.52Z",
  transform: "translate(317.409 -321.176)",
  fill: "#e9eaea"
})));

var SvgHeroLb = function SvgHeroLb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517.59,
    height: 496.071,
    viewBox: "0 0 517.59 496.071",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroLb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero-lb.d0f27eea.svg";
export { ForwardRef as ReactComponent };